<template>
  <div class="main main-add-pagamento">
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="finalizar-proposta">

            <loading
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="true"
            class="overlay-load"
            :z-index="9999"
            ></loading>

            <transition name="fade">
              <div id="step-1" class="multi-step-form active-step" v-if="etapa==='step-9'">
                <div class="d-flex align-content-center">
                  <p><img
                    src="../assets/arrow-left.svg"
                    alt="Voltar etapa"
                    @click.prevent="backtoinformacoespag()"
                    /></p>
                  </div>
                  <div class="align-flex-title" style="margin-top: -58px; justify-content: end;">
                    <h3 style="margin-left: 70px">Resumo do pedido</h3>
                  </div>
                  <b-row>
                    <b-col md="8" sm="12">
                    <!-- <b-row class="resumo-proposta protocolo-proposta" style="height: 100px;">
                      <img
                        src="../assets/protocolo.svg"
                        alt="Protocolo de atendimento"
                        style="margin-left: 37px; margin-right: 21px;"
                      />
                      <b style="margin-right: 5px">Protocolo de atendimento:</b> {{ protocolo }}
                    </b-row>
                    <b-row class="resumo-proposta protocolo-proposta-mobile" style="height: 100px;">
                      <b-col class="title-resumo-proposta">
                        <img
                          src="../assets/protocolo.svg"
                          alt="Protocolo de atendimento"
                          style="margin-left: 37px; margin-right: 21px;"
                        />
                        <span class="headline-proposta">PROTOCOLO:</span>
                      </b-col>
                      <b-col>
                        <b style="margin-right: 5px">Protocolo de atendimento:</b> {{ protocolo }}
                      </b-col>
                    </b-row> -->
                    <b-row class="resumo-proposta protocolo-proposta vigencia-flexivel">
                      <div class="pre-vigencia">
                        <img
                        src="../assets/protocolo.svg"
                        alt="Protocolo de atendimento"
                        style="margin-left: 37px; margin-right: 21px;"
                        />
                        <b style="margin-right: 5px;">Vigência do plano:</b> {{ vigenciaimediata != "" ? vigenciaimediata : datavigencia }}
                      </div>
                      <div class="box-datepicker" v-if="vigenciaFlexivel">
                        <div class="col-sm-6" style="text-align: left">Você quer fazer uma adesão imediata? (sempre posterior a D + {{ diasposterioradesaoview }} dias)</div>
                        <div class="col-sm-6" style="padding: 0">
                          <div class="col-sm-12" style="justify-content: space-between; display: flex;">
                            <b-button @click="habilitadatepickerflex = !habilitadatepickerflex" style="margin-left: 0">Sim</b-button>
                            <b-button @click="vigenciaFlexivel = false; vigenciaimediata = ''" style="margin-left: 0">Não</b-button>
                          </div>    
                          <div class="col-sm-12" v-if="habilitadatepickerflex"><date-picker 
                            v-model="vigenciaimediata"
                            v-mask="'##/##/####'"
                            valueType="format"
                            format="DD/MM/YYYY"
                            placeholder="Informe aqui a data de inicio da vigência"
                            :editable="true"
                            input-class="form-control"
                            :class="{
                              'statusok-fontbold-datepicker': vigenciaimediata.length > 9,
                            }"
                            :disabled-date="(date) => date < datainiciovigenciaflex ? true : false"
                            ></date-picker></div>
                          </div>
                        </div>
                      </b-row>
                      <b-row class="resumo-proposta protocolo-proposta-mobile vigencia-flexivel-mobile">
                        <div class="pre-vigencia">
                          <img
                          src="../assets/protocolo.svg"
                          alt="Protocolo de atendimento"
                          style="margin-left: 37px; margin-right: 21px;"
                          />
                          <b style="margin-right: 5px;">Vigência do plano:</b> {{ vigenciaimediata != "" ? vigenciaimediata : datavigencia }}
                        </div>
                        <div class="box-datepicker" v-if="vigenciaFlexivel">
                          <div class="col-sm-6" style="text-align: left">Você quer fazer uma adesão imediata? (sempre posterior a D + {{ diasposterioradesaoview }} dias)</div>
                          <div class="col-sm-6" style="justify-content: space-between; display: flex;" v-if="!habilitadatepickerflex">
                            <b-button @click="habilitadatepickerflex = !habilitadatepickerflex" style="margin-left: 0">Sim</b-button>
                            <b-button @click="vigenciaFlexivel = false" style="margin-left: 0">Não</b-button>
                          </div>    
                          <div class="col-sm-6" v-if="habilitadatepickerflex"><date-picker 
                            v-model="vigenciaimediata"
                            v-mask="'##/##/####'"
                            valueType="format"
                            format="DD/MM/YYYY"
                            placeholder="Informe aqui a data de inicio da vigência"
                            :editable="true"
                            input-class="form-control"
                            :class="{
                              'statusok-fontbold-datepicker': vigenciaimediata.length > 9,
                            }"
                            :disabled-date="(date) => date < datainiciovigenciaflex ? true : false"
                            ></date-picker></div>
                          </div>
                        </b-row>
                        <b-row class="resumo-proposta" style="width: 100%; text-align: left">
                          <div class="title-resumo-proposta">
                            <b-button class="filter-select btn-habilita-cadastro" @click="edicaocadastro = edicaocadastro ? false : true;buscaNovoCep()">{{ edicaocadastro ? 'Finalizar' : 'Editar dados' }} <img src="../assets/edit.svg" alt="Editar dados"></b-button>
                            <b-button class="filter-select btn-habilita-cadastro btn-habilita-cadastro-mobile" style="display: none" @click="edicaocadastro = edicaocadastro ? false : true"><img src="../assets/edit.svg" alt="Editar dados"></b-button>
                            <img
                            src="../assets/pessoa.svg"
                            alt="BENEFICIÁRIO TITULAR:"
                            style="margin-left: 37px; margin-right: 21px;"
                            />
                            <span class="headline-proposta">BENEFICIÁRIO TITULAR:</span>
                          </div>
                          <div class="content-resumo-proposta">
                            <p class="items-resumo-proposta">
                              <b class="bold-item-proposta">Nome:</b> 
                              <b-form-input v-if="edicaocadastro" v-model="nome" :formatter="formatter" class="finalizaproposta"></b-form-input>
                              <span v-else>{{ nome }}</span><br/>
                              <b class="bold-item-proposta">CPF:</b>
                              <b-form-input v-if="edicaocadastro" v-model="cpf" class="finalizaproposta" v-mask="'###.###.###-##'" @keydown="onKeydown($event)"></b-form-input>
                              <span v-else>{{ cpf }}</span><br/>
                              <b class="bold-item-proposta">Data de nascimento:</b>
                              <b-form-input v-if="edicaocadastro" v-model="datanasc" class="finalizaproposta" v-mask="'##/##/####'"></b-form-input> 
                              <span v-else>{{ datanasc }}</span><br/>
                              <b class="bold-item-proposta">Email:</b>
                              <b-form-input v-if="edicaocadastro" v-model="email" :formatter="formatter" class="finalizaproposta"></b-form-input> 
                              <span v-else>{{ email }}</span><br/>
                              <b class="bold-item-proposta">CEP:</b>
                              <b-form-input v-if="edicaocadastro" v-model="cep" class="finalizaproposta" v-mask="'#####-###'" @keydown="onKeydown($event)"></b-form-input> 
                              <span v-else>{{ cep }}</span><br/>
                              <b class="bold-item-proposta">Endereço:</b>
                              <b-form-input v-if="edicaocadastro" v-model="endereco" :formatter="formatter" class="finalizaproposta"></b-form-input> 
                              <span v-else>{{ endereco }}</span><br/>
                              <b class="bold-item-proposta">Numero:</b>
                              <b-form-input v-if="edicaocadastro" v-model="numero" class="finalizaproposta" @keydown="onKeydown($event)"></b-form-input> 
                              <span v-else>{{ numero }}</span><br/>
                              <b class="bold-item-proposta">Complemento:</b>
                              <b-form-input v-if="edicaocadastro" v-model="complemento" :formatter="formatter" class="finalizaproposta"></b-form-input> 
                              <span v-else>{{ complemento }}</span><br/>
                              <b class="bold-item-proposta">Estado:</b>
                              <b-form-input v-if="edicaocadastro" v-model="estado" class="finalizaproposta"></b-form-input> 
                              <span v-else>{{ estado }}</span><br/>
                              <b class="bold-item-proposta">Cidade:</b>
                              <b-form-input v-if="edicaocadastro" v-model="cidade" class="finalizaproposta"></b-form-input> 
                              <span v-else>{{ cidade }}</span><br/>
                              <b class="bold-item-proposta">Bairro:</b>
                              <b-form-input v-if="edicaocadastro" v-model="bairro" :formatter="formatter" class="finalizaproposta"></b-form-input> 
                              <span v-else>{{ bairro }}</span><br/>
                            </p>
                          </div>
                        </b-row>
                        <b-row v-for="(dependente, i) in dependentes" :key="i" class="resumo-proposta resumop-no-margin-bottom" style="width: 100%; text-align: left">
                          <div class="title-resumo-proposta">
                            <b-button class="filter-select btn-habilita-cadastro" @click="edicaocadastro = edicaocadastro ? false : true">{{ edicaocadastro ? 'Finalizar' : 'Editar dados' }} <img src="../assets/edit.svg" alt="Editar dados"></b-button>
                            <b-button class="filter-select btn-habilita-cadastro btn-habilita-cadastro-mobile" style="display: none" @click="edicaocadastro = edicaocadastro ? false : true"><img src="../assets/edit.svg" alt="Editar dados"></b-button>
                            <img
                            src="../assets/pessoa.svg"
                            alt="BENEFICIÁRIO TITULAR:"
                            style="margin-left: 37px; margin-right: 21px;"
                            />
                            <span class="headline-proposta">DEPENDENTE {{ i + 1 }}:</span>
                          </div>
                          <div class="content-resumo-proposta">
                            <p class="items-resumo-proposta">
                              <b class="bold-item-proposta">Nome:</b> 
                              <b-form-input v-if="edicaocadastro" v-model="dependentes[i].NomeDep" class="finalizaproposta"></b-form-input>
                              <span v-else>{{ dependente.NomeDep }}</span><br/>
                              <b class="bold-item-proposta">CPF:</b> 
                              <b-form-input v-if="edicaocadastro" v-model="dependentes[i].CPFDep" class="finalizaproposta" v-mask="'###.###.###-##'" @keydown="onKeydown($event)"></b-form-input>
                              <span v-else>{{ dependente.CPFDep }}</span><br/>
                              <b class="bold-item-proposta">Data de nascimento:</b> 
                              <b-form-input v-if="edicaocadastro" v-model="dependentes[i].DataNascDep" class="finalizaproposta" v-mask="'##/##/####'"></b-form-input> 
                              <span v-else>{{ dependente.DataNascDep }}</span><br/>
                              <b class="bold-item-proposta">Grau de parentesco:</b> 
                              <b-form-select v-if="edicaocadastro" v-model="dependentes[i].GrauParentescoDep" :options="options_grauparentesco" class="finalizaproposta">
                                <b-form-select-option :value="null">Selecione aqui</b-form-select-option>
                                <option value="filho">Filho</option>
                                <option value="filha">Filha</option>
                              </b-form-select>
                              <span v-else>{{ getLabelParentesco(dependentes[i].GrauParentescoDep) }}</span><br/>
                            </p>
                          </div>
                        </b-row>
                        <b-row class="btn-finalizar-call1" style="width: 100%">
                          <b-button class="btn-alianca pesquisar-planos" @click="finalizarproposta()" style="width: 100%; margin: 0;">FINALIZAR COMPRA</b-button>
                        </b-row>
                      </b-col>
                      <b-col md="4" sm="12" style="padding: 0">
                        <b-container class="card-plano card-plano-content-finaliza">
                          <b-row class="sec1-plano" style="margin-bottom: 15px; align-items: center;">
                            <div class="col-sm-3 sec1-plano-img">
                              <img style="width: 88px" :src="listaOperadoras[plano.frontoperadoraid.operadoraprotheusid].LOGO_OPERADORA" />
                              <div class="ans-selo-div" style="background: #fff; margin-top: 0!important">
                                <span class="ans-selo-op">ANS - Nº {{ listaOperadoras[plano.frontoperadoraid.operadoraprotheusid].ANS }}</span>
                              </div>
                            </div>
                            <div class="sec1-plano-texto col-sm-9" style="text-align: left; padding-left: 0px;"><p><b>Plano {{ plano.frontoperadoraid.operadoraNome }}</b> - {{ plano.descplano }}</p></div>
                          </b-row>
                          <b-row class="sec2-plano border-top-finaliza" style="padding-top: 10px">
                            <div class="col-sm-12 sec2-item-detalhe" style="justify-content: space-between; padding-right: 40px" v-b-modal.modal-plano-selecionado>
                              <div style="margin: 0; display: inherit">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="plus-circle" class="icon-plus-circle" /></div>
                                <div class="sec2-detalhes-plano">Ver todos detalhes do plano</div>
                              </div>
                              <div style="margin: 0"><font-awesome-icon icon="sort-down" class="icon-sort-down" /></div>
                            </div>
                          </b-row>
                          <b-row class="sec3-plano" style="justify-content: initial; padding-left: 27px">
                            <h4>R$ <strong>{{ formatMoney( plano.valor - plano.valor_aux )}}</strong><span>/ total a pagar</span></h4>
                          </b-row>
                        </b-container>
                        <b-modal id="modal-plano-selecionado" class="modal-detalhe-plano">
                          <template #modal-header="{ close }">
                            <h5 class="title-modal">Detalhes do <span style="color: #A01D22">plano</span></h5>
                            <b-button class="close btn-close btn-modais-nohover" aria-label="Close" @click="close()">×</b-button>
                          </template>
                      <!-- <div class="container modal-plano">
                        <div class="row row-modal-plano-header">
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Plano escolhido:</h4>
                          </div>
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Informações:</h4>
                          </div>
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Beneficiário Titular:</h4>
                          </div>
                        </div>
                        <div class="row row-modal-plano">
                          <div class="col-sm-4 col-modal-plano" style="padding-left: 0; padding-top: 0;">
                            <div class="row sec1-plano" style="padding-left: 0; padding-top: 0;">
                              <div class="col-sm-3 sec1-plano-img">
                                <img style="width: 150px" :src="require('@/assets/Operadoras/' + plano.frontoperadoraid.operadoraLogo + '.png')" />
                                <div class="ans-selo-div" style="background: #fff; margin-top: 0!important">                                  
                                  <img style="width: 100%" :src="require('@/assets/ANS/' + plano.frontoperadoraid.operadoraANS + '.png')" />
                                </div>
                              </div>
                              <div class="col-sm-12 sec1-plano-texto" style="padding: 0">{{ plano.descplano }}</div>
                            </div>
                          </div>
                          <div class="col-sm-4 col-modal-plano">
                            <div class="sec2-plano">
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="map-marker-alt" class="icon-map-marker-alt" /></div>
                                <div class="sec2-detalhes-plano"><span>Cobertura: </span> {{ getAbrangencia(plano.cobertura) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="bed" class="icon-bed" /></div>
                                <div class="sec2-detalhes-plano"><span>Acomodação: </span> {{ getAcomodacao(plano.acomodacao) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user-friends" class="icon-user-friends" /></div>
                                <div class="sec2-detalhes-plano"><span>Coparticipação: </span> {{ (plano.coparticipacao == '0') ? "Não" : "Sim" }}</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4 col-modal-plano">
                            <div class="sec2-plano">
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user" class="icon-user" /></div>
                                <div class="sec2-detalhes-plano"><span>Idade: </span> {{ calculateAge( datanasc.substr(6, 4) + '/' + datanasc.substr(3, 2) + '/' + datanasc.substr(0, 2) ) + ' anos' }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="dollar-sign" class="icon-dollar-sign" /></div>
                                <div class="sec2-detalhes-plano"><span>Valor do plano: </span> {{ formatMoney(plano.valor) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa">
                                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M8.50006 3.9C10.2801 3.9 10.9401 4.75 11.0001 6H13.2101C13.1401 4.28 12.0901 2.7 10.0001 2.19V0H7.00006V2.16C6.47006 2.28 5.97006 2.46 5.52006 2.7L6.99006 4.17C7.40006 4 7.90006 3.9 8.50006 3.9ZM1.33006 1.06L0.0600586 2.33L3.50006 5.77C3.50006 7.85 5.06006 8.98 7.41006 9.68L10.9201 13.19C10.5801 13.67 9.87006 14.1 8.50006 14.1C6.44006 14.1 5.63006 13.18 5.52006 12H3.32006C3.44006 14.19 5.08006 15.42 7.00006 15.83V18H10.0001V15.85C10.9601 15.67 11.8201 15.3 12.4501 14.73L14.6701 16.95L15.9401 15.68L1.33006 1.06Z" fill="#B34A4E"/>
                                  </svg>
                                </div>
                                <div class="sec2-detalhes-plano"><span>Auxilio: </span> {{ formatMoney(plano.valor_aux) }}</div>
                              </div>
                              <div class="sec2-item-detalhe" style="justify-content: space-between; padding-right: 40px">
                                <div style="margin: 0; display: inherit">
                                  <div class="sec2-icon-fa" style="margin-right: 20px">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.41 16.09V18H8.74V16.07C7.03 15.71 5.58 14.61 5.47 12.67H7.43C7.53 13.72 8.25 14.54 10.08 14.54C12.04 14.54 12.48 13.56 12.48 12.95C12.48 12.12 12.04 11.34 9.81 10.81C7.33 10.21 5.63 9.19 5.63 7.14C5.63 5.42 7.02 4.3 8.74 3.93V2H11.41V3.95C13.27 4.4 14.2 5.81 14.26 7.34H12.3C12.25 6.23 11.66 5.47 10.08 5.47C8.58 5.47 7.68 6.15 7.68 7.11C7.68 7.95 8.33 8.5 10.35 9.02C12.37 9.54 14.53 10.41 14.53 12.93C14.52 14.76 13.15 15.76 11.41 16.09Z" fill="#1DA090"/>
                                    </svg>
                                  </div>
                                  <div class="sec3-plano" style="border: none">
                                    <h4>R$ <strong>{{ formatMoney(plano.valor - plano.valor_aux) }}</strong><span>/mês</span></h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div> -->
                      <div class="container modal-plano">
                        <div class="row row-modal-plano-header">
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Plano escolhido:</h4>
                          </div>
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Informações:</h4>
                          </div>
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Resumo do pedido:</h4>
                          </div>
                        </div>
                        <div class="row row-modal-plano">
                          <div class="col-sm-4 col-modal-plano" style="padding-left: 0; padding-top: 0;">
                            <div class="row sec1-plano" style="padding-left: 0; padding-top: 0;">
                              <div class="col-sm-3 sec1-plano-img">
                                <img style="width: 150px" :src="listaOperadoras[plano.frontoperadoraid.operadoraprotheusid].LOGO_OPERADORA" />
                                <div class="ans-selo-div" style="background: #fff; margin-top: 0!important">
                                  <span class="ans-selo-op">ANS - Nº {{ listaOperadoras[plano.frontoperadoraid.operadoraprotheusid].ANS }}</span>
                                </div>
                              </div>
                              <div class="col-sm-12 sec1-plano-texto" style="padding: 0">{{ plano.descplano }}</div>
                            </div>
                          </div>
                          <div class="col-sm-4 col-modal-plano">
                            <div class="sec2-plano">
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="map-marker-alt" class="icon-map-marker-alt" /></div>
                                <div class="sec2-detalhes-plano"><span>Cobertura: </span> {{ getAbrangencia(plano.cobertura) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="bed" class="icon-bed" /></div>
                                <div class="sec2-detalhes-plano"><span>Acomodação: </span> {{ getAcomodacao(plano.acomodacao) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user-friends" class="icon-user-friends" /></div>
                                <div class="sec2-detalhes-plano"><span>Coparticipação: </span> {{ (plano.coparticipacao == '0') ? "NÃO" : "SIM"  }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user" class="icon-user" /></div>
                                <div class="sec2-detalhes-plano"><span>Idade Titular: </span> {{ calculateAge( datanasc.substr(6, 4) + '/' + datanasc.substr(3, 2) + '/' + datanasc.substr(0, 2) ) + ' anos' }}</div>
                              </div>
                              <div v-if="dependentes != null" class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user" class="icon-user" /></div>
                                <div class="sec2-detalhes-plano"><span>Quantidade de dependentes: </span> {{ dependentes.length }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="dollar-sign" class="icon-dollar-sign" /></div>
                                <div class="sec2-detalhes-plano"><span>Valor do plano: </span> {{ formatMoney(plano.valor) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa">
                                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.50006 3.9C10.2801 3.9 10.9401 4.75 11.0001 6H13.2101C13.1401 4.28 12.0901 2.7 10.0001 2.19V0H7.00006V2.16C6.47006 2.28 5.97006 2.46 5.52006 2.7L6.99006 4.17C7.40006 4 7.90006 3.9 8.50006 3.9ZM1.33006 1.06L0.0600586 2.33L3.50006 5.77C3.50006 7.85 5.06006 8.98 7.41006 9.68L10.9201 13.19C10.5801 13.67 9.87006 14.1 8.50006 14.1C6.44006 14.1 5.63006 13.18 5.52006 12H3.32006C3.44006 14.19 5.08006 15.42 7.00006 15.83V18H10.0001V15.85C10.9601 15.67 11.8201 15.3 12.4501 14.73L14.6701 16.95L15.9401 15.68L1.33006 1.06Z" fill="#B34A4E"/>
                                  </svg>
                                </div>
                                <div class="sec2-detalhes-plano"><span>Auxilio: </span> {{ formatMoney(plano.valor_aux) }}</div>
                              </div>
                              <div class="sec2-item-detalhe" style="justify-content: space-between; padding-right: 40px">
                                <div style="margin: 0; display: inherit">
                                  <div class="sec2-icon-fa" style="margin-right: 20px">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.41 16.09V18H8.74V16.07C7.03 15.71 5.58 14.61 5.47 12.67H7.43C7.53 13.72 8.25 14.54 10.08 14.54C12.04 14.54 12.48 13.56 12.48 12.95C12.48 12.12 12.04 11.34 9.81 10.81C7.33 10.21 5.63 9.19 5.63 7.14C5.63 5.42 7.02 4.3 8.74 3.93V2H11.41V3.95C13.27 4.4 14.2 5.81 14.26 7.34H12.3C12.25 6.23 11.66 5.47 10.08 5.47C8.58 5.47 7.68 6.15 7.68 7.11C7.68 7.95 8.33 8.5 10.35 9.02C12.37 9.54 14.53 10.41 14.53 12.93C14.52 14.76 13.15 15.76 11.41 16.09Z" fill="#1DA090"/>
                                    </svg>
                                  </div>
                                  <div class="sec3-plano" style="border: none">
                                    <h4>R$ <strong>{{ formatMoney(calculaPrecoReal(plano.valor - plano.valor_aux)) }}</strong><span>/mês</span></h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4 col-modal-plano" style="overflow: auto; max-height: 320px;">
                            <div class="sec2-plano">
                              <div v-for="(beneficiario, i) in valordetalhes" :key="i"  class="sec2-item-detalhe-other">
                                <div class="sec2-detalhes-plano">
                                  <span> 
                                    {{ beneficiario.nome }} 
                                  </span>
                                </div>
                                <div class="sec2-detalhes-plano">
                                  <span>Plano: </span> 
                                  <span v-if="beneficiario.valor > 0" style="font-weight: normal">R$ {{ formatMoney(beneficiario.valor) }}</span>
                                  <vue-content-loading :height="100" v-else style="margin-left: 150px">
                                    <rect x="0" y="0" width="600px" height="100px" />
                                  </vue-content-loading>
                                </div>
                                <div v-if="tipoorgaoentidade == 'Orgão'" class="sec2-detalhes-plano">
                                  <span>Auxílio: </span> 
                                  <span v-if="beneficiario.auxilio > 0" style="font-weight: normal">- R$ {{ formatMoney(beneficiario.auxilio) }}</span>
                                  <vue-content-loading :height="100" v-else style="margin-left: 150px">
                                    <rect x="0" y="0" width="600px" height="100px" />
                                  </vue-content-loading>
                                </div>
                                <template v-if="beneficiario.opcionais != null">
                                  <div v-for="(item, i) of beneficiario.opcionais" :key="i"> 
                                    <div v-if="item.selected == true" class="sec2-detalhes-plano">
                                      <span>{{ formataCapitalizado(item.nomeopcional) }}: </span> 
                                      <span style="font-weight: normal">+ R$ {{ formatMoney(item.valoropcional) }}</span>
                                    </div>
                                  </div>
                                </template>
                                <div class="sec2-detalhes-plano">
                                  <span>Valor Total: </span> 
                                  <span v-if="beneficiario.valor > 0"> R$ {{ formatMoney(calculaPrecoFinal(beneficiario.valor - beneficiario.auxilio, i)) }}</span>
                                  <vue-content-loading :height="100" v-else style="margin-left: 150px">
                                    <rect x="0" y="0" width="600px" height="100px" />
                                  </vue-content-loading>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="container modal-plano modal-plano-mobile" style="display: none">
                        <div class="row row-modal-plano">
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Plano escolhido:</h4>
                          </div>
                          <div class="col-sm-4 col-modal-plano" style="padding-left: 0; padding-top: 0;">
                            <div class="row sec1-plano" style="padding-left: 0; padding-top: 0;">
                              <div class="col-sm-3 sec1-plano-img">
                                <img style="width: 150px" :src="listaOperadoras[plano.frontoperadoraid.operadoraprotheusid].LOGO_OPERADORA" />
                                <div class="ans-selo-div" style="background: #fff; margin-top: 0!important">
                                  <span class="ans-selo-op">ANS - Nº {{ listaOperadoras[plano.frontoperadoraid.operadoraprotheusid].ANS }}</span>
                                </div>
                              </div>
                              <div class="col-sm-12 sec1-plano-texto" style="padding: 0">{{ plano.descplano }}</div>
                            </div>
                          </div>
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Informações:</h4>
                          </div>
                          <div class="col-sm-4 col-modal-plano">
                            <div class="sec2-plano">
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="map-marker-alt" class="icon-map-marker-alt" /></div>
                                <div class="sec2-detalhes-plano"><span>Cobertura: </span> {{ getAbrangencia(plano.cobertura) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="bed" class="icon-bed" /></div>
                                <div class="sec2-detalhes-plano"><span>Acomodação: </span> {{ getAcomodacao(plano.acomodacao) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user-friends" class="icon-user-friends" /></div>
                                <div class="sec2-detalhes-plano"><span>Coparticipação: </span> {{ (plano.coparticipacao == '0') ? "NÃO" : "SIM"  }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user" class="icon-user" /></div>
                                <div class="sec2-detalhes-plano"><span>Idade Titular: </span> {{ calculateAge( datanasc.substr(6, 4) + '/' + datanasc.substr(3, 2) + '/' + datanasc.substr(0, 2) ) + ' anos' }}</div>
                              </div>
                              <div v-if="dependentes != null" class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="user" class="icon-user" /></div>
                                <div class="sec2-detalhes-plano"><span>Quantidade de dependentes: </span> {{ dependentes.length }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa"><font-awesome-icon icon="dollar-sign" class="icon-dollar-sign" /></div>
                                <div class="sec2-detalhes-plano"><span>Valor do plano: </span> {{ formatMoney(plano.valor) }}</div>
                              </div>
                              <div class="sec2-item-detalhe">
                                <div class="sec2-icon-fa">
                                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.50006 3.9C10.2801 3.9 10.9401 4.75 11.0001 6H13.2101C13.1401 4.28 12.0901 2.7 10.0001 2.19V0H7.00006V2.16C6.47006 2.28 5.97006 2.46 5.52006 2.7L6.99006 4.17C7.40006 4 7.90006 3.9 8.50006 3.9ZM1.33006 1.06L0.0600586 2.33L3.50006 5.77C3.50006 7.85 5.06006 8.98 7.41006 9.68L10.9201 13.19C10.5801 13.67 9.87006 14.1 8.50006 14.1C6.44006 14.1 5.63006 13.18 5.52006 12H3.32006C3.44006 14.19 5.08006 15.42 7.00006 15.83V18H10.0001V15.85C10.9601 15.67 11.8201 15.3 12.4501 14.73L14.6701 16.95L15.9401 15.68L1.33006 1.06Z" fill="#B34A4E"/>
                                  </svg>
                                </div>
                                <div class="sec2-detalhes-plano"><span>Auxilio: </span> {{ formatMoney(plano.valor_aux) }}</div>
                              </div>
                              <div class="sec2-item-detalhe" style="justify-content: space-between; padding-right: 40px">
                                <div style="margin: 0; display: inherit">
                                  <div class="sec2-icon-fa" style="margin-right: 20px">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11.41 16.09V18H8.74V16.07C7.03 15.71 5.58 14.61 5.47 12.67H7.43C7.53 13.72 8.25 14.54 10.08 14.54C12.04 14.54 12.48 13.56 12.48 12.95C12.48 12.12 12.04 11.34 9.81 10.81C7.33 10.21 5.63 9.19 5.63 7.14C5.63 5.42 7.02 4.3 8.74 3.93V2H11.41V3.95C13.27 4.4 14.2 5.81 14.26 7.34H12.3C12.25 6.23 11.66 5.47 10.08 5.47C8.58 5.47 7.68 6.15 7.68 7.11C7.68 7.95 8.33 8.5 10.35 9.02C12.37 9.54 14.53 10.41 14.53 12.93C14.52 14.76 13.15 15.76 11.41 16.09Z" fill="#1DA090"/>
                                    </svg>
                                  </div>
                                  <div class="sec3-plano" style="border: none">
                                    <h4>R$ <strong>{{ formatMoney(calculaPrecoReal(plano.valor - plano.valor_aux)) }}</strong><span>/mês</span></h4>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-4 col-modal-plano-header">
                            <h4>Resumo do pedido:</h4>
                          </div>
                          <div class="col-sm-4 col-modal-plano">
                            <div class="sec2-plano">
                              <div v-for="(beneficiario, i) in valordetalhes" :key="i"  class="sec2-item-detalhe-other">
                                <div class="sec2-detalhes-plano">
                                  <span> 
                                    {{ beneficiario.nome }} 
                                  </span>
                                </div>
                                <div class="sec2-detalhes-plano">
                                  <span>Plano: </span> 
                                  <span v-if="beneficiario.valor > 0" style="font-weight: normal">R$ {{ formatMoney(beneficiario.valor) }}</span>
                                  <vue-content-loading :height="100" v-else style="margin-left: 150px">
                                    <rect x="0" y="0" width="600px" height="100px" />
                                  </vue-content-loading>
                                </div>
                                <div v-if="tipoorgaoentidade == 'Orgão'" class="sec2-detalhes-plano">
                                  <span>Auxílio: </span> 
                                  <span v-if="beneficiario.auxilio > 0" style="font-weight: normal">- R$ {{ formatMoney(beneficiario.auxilio) }}</span>
                                  <vue-content-loading :height="100" v-else style="margin-left: 150px">
                                    <rect x="0" y="0" width="600px" height="100px" />
                                  </vue-content-loading>
                                </div>
                                <template v-if="beneficiario.opcionais != null">
                                  <div v-for="(item, i) of beneficiario.opcionais" :key="i"> 
                                    <div v-if="item.selected == true" class="sec2-detalhes-plano">
                                      <span>{{ formataCapitalizado(item.nomeopcional) }}: </span> 
                                      <span style="font-weight: normal">+ R$ {{ formatMoney(item.valoropcional) }}</span>
                                    </div>
                                  </div>
                                </template>
                                <div class="sec2-detalhes-plano">
                                  <span>Valor Total: </span> 
                                  <span v-if="beneficiario.valor > 0"> R$ {{ formatMoney(calculaPrecoFinal(beneficiario.valor - beneficiario.auxilio, i)) }}</span>
                                  <vue-content-loading :height="100" v-else style="margin-left: 150px">
                                    <rect x="0" y="0" width="600px" height="100px" />
                                  </vue-content-loading>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <template #modal-footer><span></span></template>
                    </b-modal>
                    <b-row style="width: 100%; margin-left: 0; margin-top: 24px">
                      <b-button class="btn-alianca pesquisar-planos" @click="finalizarproposta()" style="width: 100%; margin: 0;">FINALIZAR COMPRA</b-button>
                    </b-row>
                  </b-col>
                </b-row>
              </div>
            </transition>

          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueMask from 'v-mask'
  import store from "../store"
  import lerCodigoContato from "@/services/lerCodigoContato"
  import inserirContato from "@/services/inserirContato"
  import atualizarContato from "@/services/atualizarContato"
  import salvarPreVenda from "@/services/salvarPreVenda"
  import salvarDPS from "@/services/salvarDPS"
  import salvarOpcionais from "@/services/salvarOpcionais"
  import criptografar from "@/services/criptografar"
  import verificaVigenciaDiferenciada from "@/services/verificaVigenciaDiferenciada"
  import retornaDiasPosteriorAdesao from "@/services/retornaDiasPosteriorAdesao"
  import retornaDataPosteriorAdesao from "@/services/retornaDataPosteriorAdesao"
  import marcarPropostaComoAtivada from "@/services/marcarPropostaComoAtivada"
  import marcarPropostaComoSeVigenciaFlexivel from "@/services/marcarPropostaComoSeVigenciaFlexivel"
  import diaUtil from "@/services/diaUtil"
  import Loading from "vue-loading-overlay"
  import "vue2-datepicker/index.css"
  import "vue2-datepicker/locale/pt-br"
  import buscarEnderecoAPI from "@/services/buscarEnderecoAPI";
  Vue.use(VueMask);

  export default {
    name: 'Finalizar',
    mixins: [],
    components: {
      Loading
    },
    data(){
      return {
        nome: store.getters.getAliancaNome,
        cpf: store.getters.getAliancaUsrCPF,
        datanasc: store.getters.getAliancaDataNasc,
        email: store.getters.getAliancaEmail,
        cep: store.getters.getAliancaCEP,
        endereco: store.getters.getAliancaEndRua,
        numero: store.getters.getAliancaEndNumero,
        estado: store.getters.getAliancaEndUF,
        cidade: store.getters.getAliancaEndCidade,
        bairro: store.getters.getAliancaEndBairro,
        complemento: store.getters.getAliancaEndComp,
        dependentes: store.getters.getAliancaObjDependentes,
        nudocumento: store.getters.getAliancaDocumentoNumero,
        telefone: store.getters.getAliancaTelefone,
        sexo: store.getters.getAliancaSexoTitular,
        enderecoTipo: store.getters.getAliancaTipoEndereco,
        codigoConvenio: store.getters.getAliancaNumeroContrato,
        pesoTitular: store.getters.getAliancaObjDPS[0][0].valor,
        alturaTitular: store.getters.getAliancaObjDPS[1][0].valor,
        codOperdora: store.getters.getAliancaSelectedPlano.frontoperadoraid.operadoraprotheusid,
        formaPagamento: store.getters.getAliancaFormaPagamento,
        infoConta: store.getters.getAliancaInfoConta,
        infoContaAdd: store.getters.getAliancaObjInfoPagamento,
        objpagamentoaux: store.getters.getAliancaObjInfoPagamento,
        aliancaDocumentoUf: store.getters.getAliancaDocumentoUf,
        aliancaDocumentoExpedicao: store.getters.getAliancaDocumentoDtExpedicao,
        aliancaDocumentoOrgao: store.getters.getAliancaDocumentoOrgao.split(' '),
        dataAdmissao: store.getters.getAliancaTitularDataAdmissaoOrgao,
        etapa: 'step-9',
        errors: [],
        edicaocadastro: false,
        protocolo: 5215689968,
        plano: store.getters.getAliancaSelectedPlano,
        valordetalhes: store.getters.getAliancaSelectedPlano.detalhes,
        loading: false,
        abrangencialabels: [],
        acomodacaolabels: [],
        dps: store.getters.getAliancaObjDPS,
        datavigencia: '',
        diasposterioradesao: 0,
        diasposterioradesaoview: 0,
        vigenciaimediata: "",
        vigenciaFlexivel: false,
        datainiciovigenciaflex: '',
        habilitadatepickerflex: false,
        tipoorgaoentidade: '',
        url: "",
      }
    },
    methods: {
      buscaNovoCep(){
        this.buscarEndereco();
      },
      async buscarEndereco(cep) {
      if (cep == "01313020") {
        this.getEstadoSigla("SP");
        store.commit("mutAliancaCEP", cep);
        store.commit("mutAliancaCodEnd", null);
        store.commit("mutAliancaEndBairro", "BELA VISTA");
        store.commit("mutAliancaEndCidade", "SÃO PAULO");
        store.commit("mutAliancaEndComp", "");
        store.commit("mutAliancaEndRua", "RUA DOUTOR PLÍNIO BARRETO");
        store.commit("mutAliancaEndGia", "");
        store.commit("mutAliancaEndIbge", "");
        store.commit("mutAliancaEndTipo", "");
        store.commit("mutAliancaEndUF", "SP");

        return false;
      }

      this.isLoading = true;
      var endereco = await buscarEnderecoAPI({
        uf: "",
        cep: this.cep.replace("-", ""),
        bairro: "",
        cidade: "",
        endereco_benef: "",
      });

      this.endereco = endereco[0].ENDERECO_BENEF;
      this.bairro = endereco[0].BAIRRO;
      this.cidade = endereco[0].CIDADE;
      this.estado = endereco[0].UF;
      this.isLoading = false;

      if (!endereco[0]) {
        this.$bvToast.toast("CEP não encontrado", {
          variant: "danger",
          solid: true,
        });

        return false;
      }

      return true;
    },
      formatter(val){
        return val.toUpperCase();
      },
      getAbrangencia(id){
        return this.abrangencialabels[parseInt(id, 10)]
      },
      getAcomodacao(id){
        return this.acomodacaolabels[id.toString()]
      },
      getLabelParentesco(id){
        let label = ''
        this.options_grauparentesco.map((obj) => {
          if (obj.value == id) label = obj.text
        })
        return label
      },
      calculaPrecoReal(valor){
        for (let i = 0; i < this.valordetalhes.length; i++){
          let opcionais = this.valordetalhes[i].opcionais
          let accvalor = 0

          if(opcionais != null){
            for (const item of opcionais){
              if (item.selected == true) accvalor += item.valoropcional
            }
          valor += accvalor
        }
      }
      return valor
    },
    calculaPrecoFinal(valor, i){
      let opcionais = this.valordetalhes[i].opcionais

      if(opcionais != null){
        let accvalor = 0
        for (const item of opcionais){
          if (item.selected == true) accvalor += item.valoropcional
        }
      valor += accvalor
    }

    return valor
  },
  formataCapitalizado(texto){
    return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase()
  },
  async preparaFiltros(){
    this.abrangencialabels = store.getters.getAliancaPlanosFiltrosAbrangencias
    this.acomodacaolabels = store.getters.getAliancaPlanosFiltrosAcomodacoes
  },
  formatMoney(amount, decimalCount = 2, decimal = ",", thousands = ".") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  },
  calculateAge(date) {
    let currentDate = new Date();
    let birthDate = new Date(date);
    let difference = currentDate - birthDate;
    let age = Math.floor(difference/31557600000);
    return age
  },
  onKeydown: function(e) {

    if (
          // permite somente numeros
          (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) ||
          // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
          /^(8|9|13|46|37|39|17)$/.test(e.keyCode) ||
          // permite ctrl+ c,v,x,a,z
          /^(67|86|88|65|90)$/.test(e.keyCode) && e.ctrlKey
          ) return;
      e.preventDefault();
    e.stopPropagation();        

  },     
  backtoinformacoespag(){
    store.commit('mutAliancaObjInfoPagamento', null)
    this.$router.push("informacoes-pagamento")
  },
  async defineVigenciaFlexivel(){
    let dataposterioradesao = await retornaDataPosteriorAdesao({
      Z8_CODEMP: this.planoReal.objoperadorareal.CODIGO_OPERADORA, 
      Z8_SUBCON: this.planoReal.objoperadorareal.NUMERO_SUBCONTRATO, 
      Z8_GRPCOB: store.getters.getAliancaNumeroContrato,
      DTSELECIONADA: "20210325"
    })
    if (dataposterioradesao != undefined) console.log(dataposterioradesao.vigencia)
  },
async preparaVigenciaFlexivel(){
  let anoatual = new Date().getFullYear()
  let mesatual = new Date().getMonth()
  let hoje = new Date().getDate()
  let data = new Date(anoatual, mesatual, parseInt(hoje) + parseInt(this.diasposterioradesao), 0, 0, 0, 0)
  data = data.getFullYear() + '' + ((data.getMonth() + 1) < 10 ? '0' + (data.getMonth() + 1) : (data.getMonth() + 1)) + '' + (data.getDate() < 10 ? '0' + data.getDate() : data.getDate())
  let datainicio = await diaUtil(data)
        return new Date(datainicio.data) // .toLocaleDateString()
      },
      getVigencia(dataVenda){

        let anoatual = new Date().getFullYear()
        let mesatual = new Date().getMonth()
        let hoje = new Date().getDate()
        let datasetada = new Date(anoatual, mesatual, dataVenda, 0, 0, 0, 0)
        let vigencia = ''

        if (hoje <= datasetada.getDate()) vigencia = new Date(anoatual, mesatual + 1, 1, 0, 0, 0, 0)
          else vigencia = new Date(anoatual, mesatual + 2, 1, 0, 0, 0, 0)

            return vigencia
        },
        async finalizarproposta(){

          this.loading = true

          let dataString = this.datanasc.split("/");
          let data = `${dataString[2]}${dataString[1]}${dataString[0]}`
          console.log('data correta', data)

          let dataExpedicao = this.aliancaDocumentoExpedicao.split("/");
          let dataExp = `${dataExpedicao[2]}${dataExpedicao[1]}${dataExpedicao[0]}`

          const codigoContato = await lerCodigoContato({cpf: this.cpf.replace('.','').replace('.','').replace('-',''), sexo: this.sexo, dataNascimento: data, nome: this.nome})

          const ddd = this.telefone.substr(1,2)
          const telefone = this.telefone.substr(5,10).replace('-','')

          /***********************
            
           Inserir Beneficiarios

           ************************/

           var codigosContatos = []

           if(codigoContato == undefined){
            codigosContatos.push(await inserirContato({
              beneficiario: {
                nome: this.nome,
                cpf: this.cpf.replace('.','').replace('.','').replace('.','').replace('-',''),
                sexo: this.sexo.toString(),
                estado_civil: store.getters.getAliancaTitularEstadoCivil,
                data_nascimento: data,
                nu_documento: this.nudocumento.replace('.','').replace('.','').replace('-',''),
                orgao_emissor: this.aliancaDocumentoOrgao[0],
                uf_orgao_emissor: this.aliancaDocumentoUf,
                tipo_documento: store.getters.getAliancaDocumentoTipo,
                data_expedicao: dataExp,
                ocupacao_principal: store.getters.getAliancaProfissao,
                nome_mae: store.getters.getAliancaTitularNomeMae,
                cartao_nacional_saude: "",
                pis_pasep: "",
                num_declaracao_nascido_vivo: "",
                ddd_res: telefone.length > 8 ? "" : ddd,
                telefone_residencial: telefone.length > 8 ? "" : telefone,
                ddd_cel: telefone.length > 8 ? ddd : "",
                telefone_celular: telefone.length > 8 ? telefone : "",
                ddd_com: "",
                telefone_comercial: "",
                ramal: "",
                email: this.email,
                endereco_benef: {
                  endereco_benef: this.endereco,
                  bairro: this.bairro,
                  cidade: this.cidade,
                  uf: this.estado,
                  cep: this.cep.replace('-',''),
                  numero: this.numero || "",
                  complemento: this.complemento,
                  tipo_endereco: this.enderecoTipo || "",
                  codmun: "",
                },
                peso: Number(this.pesoTitular.match(/\d/gmi).join('')),
                altura: Number(this.alturaTitular.match(/\d/gmi).join('')),
              },
              proposta:{
                matricula_reg_entidade: "",
                codigo_convenio: this.codigoConvenio,
                nome_responsavel: "",
                cpf_responsavel: ""
              }
            }))
          }
          else {
            await atualizarContato({
              beneficiario: {
                nome: this.nome,
                codContato: codigoContato.codigoContato,
                cpf: this.cpf.replace('.','').replace('.','').replace('.','').replace('-',''),
                sexo: this.sexo.toString(),
                estado_civil: store.getters.getAliancaTitularEstadoCivil,
                data_nascimento: data,
                nu_documento: this.nudocumento.replace('.','').replace('.','').replace('-',''),
                orgao_emissor: this.aliancaDocumentoOrgao[0],
                uf_orgao_emissor: this.aliancaDocumentoUf,
                tipo_documento: store.getters.getAliancaDocumentoTipo,
                data_expedicao: dataExp,
                ocupacao_principal: store.getters.getAliancaProfissao,
                nome_mae: store.getters.getAliancaTitularNomeMae,
                cartao_nacional_saude: "",
                pis_pasep: "",
                num_declaracao_nascido_vivo: "",
                ddd_res: telefone.length > 8 ? "" : ddd,
                telefone_residencial: telefone.length > 8 ? "" : telefone,
                ddd_cel: telefone.length > 8 ? ddd : "",
                telefone_celular: telefone.length > 8 ? telefone : "",
                ddd_com: "",
                telefone_comercial: "",
                ramal: "",
                email: this.email,
                endereco_benef: {
                  endereco_benef: this.endereco,
                  bairro: this.bairro,
                  cidade: this.cidade,
                  uf: this.estado,
                  cep: this.cep.replace('-',''),
                  numero: this.numero,
                  complemento: this.complemento,
                  tipo_endereco: this.enderecoTipo || "",
                  codmun: "",
                },
                peso: parseInt(this.pesoTitular),
                altura: this.alturaTitular,
              },
              proposta:{
                matricula_reg_entidade: "",
                codigo_convenio: this.codigoConvenio,
                nome_responsavel: "",
                cpf_responsavel: ""
              }
            })
            codigosContatos.push(codigoContato.codigoContato)
          }

          let i = 1
          for(const dependente of this.dependentes){
            let dataStringDep = dependente.DataNascDep.split("/");
            let dataDep = `${dataStringDep[2]}${dataStringDep[1]}${dataStringDep[0]}`

            let dataExpedicaoString = dependente.documentoDtExpedicao.split("/");
            let dataExpedicao = `${dataExpedicaoString[2]}${dataExpedicaoString[1]}${dataExpedicaoString[0]}`
            const codigoContatoDep = await lerCodigoContato({cpf: dependente.CPFDep.replace('.','').replace('.','').replace('-',''), sexo: dependente.sexo == "Masculino" ? "1" : "2", dataNascimento: dataDep, nome: dependente.NomeDep})

            if(codigoContatoDep == undefined) {
              codigosContatos.push(
                await inserirContato({
                  beneficiario: {
                    nome: dependente.NomeDep,
                    cpf: dependente.CPFDep.replace('.','').replace('.','').replace('-',''),
                    sexo: dependente.sexo == "Masculino" ? "1" : "2",
                    estado_civil: dependente.estadocivil,
                    data_nascimento: dataDep,
                    nu_documento: dependente.documentoNumerodep.replace('.','').replace('.','').replace('-',''),
                    orgao_emissor: dependente.documentoOrgao.split(' ')[0],
                    uf_orgao_emissor: dependente.documentoUf,
                    tipo_documento: dependente.documentoTipodep,
                    data_expedicao: dataExpedicao,
                    ocupacao_principal: "",
                    nome_mae: dependente.nomemae,
                    cartao_nacional_saude: "",
                    pis_pasep: "",
                    num_declaracao_nascido_vivo: dependente.certidaonascidovivo,
                    ddd_res: "",
                    telefone_residencial: "",
                    ddd_cel: "",
                    telefone_celular: "",
                    ddd_com: "",
                    telefone_comercial: "",
                    ramal: "",
                    email: this.email,
                    endereco_benef: {
                      endereco_benef: this.endereco,
                      bairro: this.bairro,
                      cidade: this.cidade,
                      uf: this.estado,
                      cep: this.cep.replace('-',''),
                      numero: this.numero,
                      complemento: this.complemento,
                      tipo_endereco: this.enderecoTipo || "",
                      codmun: "",
                    },
                    peso: this.dps[0][i].valor.replace(",", "."),
                    altura: this.dps[1][i].valor.replace(",", "."),
                  },
                  proposta:{
                    matricula_reg_entidade: "",
                    codigo_convenio: this.codigoConvenio,
                    nome_responsavel: "",
                    cpf_responsavel: ""
                  }
                })
                )
            }
            else {
              await atualizarContato({
                beneficiario: {
                  nome: dependente.NomeDep,
                  codContato: codigoContatoDep.codigoContato,
                  cpf: dependente.CPFDep.replace('.','').replace('.','').replace('-',''),
                  sexo: dependente.sexo == "Masculino" ? "1" : "2",
                  estado_civil: dependente.estadocivil,
                  data_nascimento: dataDep,
                  nu_documento: dependente.documentoNumerodep.replace('.','').replace('.','').replace('-',''),
                  orgao_emissor: dependente.documentoOrgao.split(' ')[0],
                  uf_orgao_emissor: dependente.documentoUf,
                  tipo_documento: dependente.documentoTipodep,
                  data_expedicao: dataExpedicao,
                  ocupacao_principal: "",
                  nome_mae: dependente.nomemae,
                  cartao_nacional_saude: "",
                  pis_pasep: "",
                  num_declaracao_nascido_vivo: dependente.certidaonascidovivo,
                  ddd_res: "",
                  telefone_residencial: "",
                  ddd_cel: "",
                  telefone_celular: "",
                  ddd_com: "",
                  telefone_comercial: "",
                  ramal: "",
                  email: this.email,
                  endereco_benef: {
                    endereco_benef: this.endereco,
                    bairro: this.bairro,
                    cidade: this.cidade,
                    uf: this.estado,
                    cep: this.cep.replace('-',''),
                    numero: this.numero,
                    complemento: this.complemento,
                    tipo_endereco: this.enderecoTipo || "",
                    codmun: "",
                  },
                  peso: this.dps[0][i].valor,
                  altura: this.dps[1][i].valor,
                },
                proposta:{
                  matricula_reg_entidade: "",
                  codigo_convenio: this.codigoConvenio,
                  nome_responsavel: "",
                  cpf_responsavel: ""
                }
              })
              codigosContatos.push(codigoContatoDep.codigoContato)
            }

            i++
          }

          let beneficiarios = []

          beneficiarios.push({
            codigo_contato: `${codigosContatos[0]}`,
            codigo_index: store.getters.getAliancaProposta != null ? store.getters.getAliancaProposta.beneficiarios[0].codigo_index : "0",
            tipo_usuario: "T",
            grau_parentesco: "01",
            carencia: "002",
            data_admissao: "",
            matricula_anterior: "",
            plano_principal: {
              codigo_plano: this.planoReal.objplanoreal.codPlano,
              versao_plano: this.planoReal.objplanoreal.bi3_versao,
              tipo_produto: this.planoReal.objplanoreal.tipoPlano,
              valor: this.plano.detalhes[0].valor
            },
            endereco_benef: {
              uf: this.estado
            }
          })

          for(var f = 0; f < this.dependentes.length; f++) {
            beneficiarios.push({
              codigo_contato: `${codigosContatos[f + 1]}`,
              codigo_index: store.getters.getAliancaProposta != null ? store.getters.getAliancaProposta.beneficiarios[f + 1].codigo_index : "",
              tipo_usuario: "D",
              grau_parentesco: this.dependentes[f].GrauParentescoDep,
              carencia: "002",
              data_admissao: "",
              matricula_anterior: "",
              plano_principal: {
                codigo_plano: this.planoReal.objplanoreal.codPlano,
                versao_plano: this.planoReal.objplanoreal.bi3_versao,
                tipo_produto: this.planoReal.objplanoreal.tipoPlano,
                valor: this.plano.detalhes[f + 1].valor
              },
              endereco_benef: {
                uf: this.estado
              }
            })
          }

          /***********************
            
           Salvar prevenda 

           ************************/

           let vigencia = String( this.getVigencia(this.planoReal.objoperadorareal.DATA_LIM_VENDA, this.planoReal.objoperadorareal.DATA_EXPORT).toLocaleDateString() )
           vigencia = vigencia.substr(6, 4) + '' + vigencia.substr(3, 2) + '' + vigencia.substr(0, 2)

           if (this.vigenciaFlexivel) vigencia = this.vigenciaimediata != "" ? ( this.vigenciaimediata.substr(6, 4) + '' + this.vigenciaimediata.substr(3, 2) + '' + this.vigenciaimediata.substr(0, 2) ) : vigencia

            let retornosalvarprevenda = await salvarPreVenda(
            {
              proposta: {
                origem: "3",
                tipo_prevenda: "1",
                num_proposta: store.getters.getAliancaProposta != null ? store.getters.getAliancaProposta.num_proposta : "",
                atendimento: "000000",
                data_vigencia: vigencia,
                status: "100",
                grupo_cobranca: {
                  codigo_convenio: this.codigoConvenio,
                  matricula_reg_entidade: store.getters.getAliancaMatriculaRegOrgaoEntidade
                },
                operadora: {
                  codigo_operadora: this.codOperdora,
                  numero_contrato: this.planoReal.objplanoreal.bqc_numcon,
                  versao_contrato: this.planoReal.objplanoreal.bqc_vercon,
                  numero_subcontrato: this.planoReal.objplanoreal.bqc_subcon,
                  versao_subcontrato: this.planoReal.objplanoreal.bqc_versub,
                  codigo_questionario: this.planoReal.objoperadorareal.CODIGO_QUESTIONARIO
                },
                beneficiarios: beneficiarios,
                dados_cobranca: {
                  forma_pagamento: this.formaPagamento,
                  dia_vencimento: this.infoContaAdd.diasvencimento ? parseInt(this.infoContaAdd.diasvencimento) : 2,
                  cpf_responsavel: this.infoContaAdd.cpfrespfinanceiro ? this.infoContaAdd.cpfrespfinanceiro : "",
                  nome_responsavel: this.infoContaAdd.nomerespfinanceiro ? this.infoContaAdd.nomerespfinanceiro : "",
                  email_responsavel: this.infoContaAdd.emailrespfinanceiro ? this.infoContaAdd.emailrespfinanceiro : "",
                  banco: {
                    codigo_banco: this.infoConta.banco ? this.infoConta.banco : "",
                    agencia: this.infoConta.agencia ? this.infoConta.agencia: "",
                    digito_agencia: this.infoConta.digitoag ? this.infoConta.digitoag : "",
                    conta: this.infoConta.conta ? this.infoConta.conta.substr(0,this.infoConta.conta.length -1) : "",
                    digito_conta: this.infoConta.conta ? this.infoConta.conta.substr(this.infoConta.conta.length -1, 1) : "",
                    tipo_operacao: "",
                    tipo_conta: this.infoConta.tipoconta ? this.infoConta.tipoconta : "",
                    codigo_banco_reembolso: this.infoContaAdd.infocontaopcional.banco ? this.infoContaAdd.infocontaopcional.banco : "",
                    agencia_reembolso: this.infoContaAdd.infocontaopcional.agencia ? this.infoContaAdd.infocontaopcional.agencia : "",
                    digito_agencia_reembolso: this.infoContaAdd.infocontaopcional.digitoag ? this.infoContaAdd.infocontaopcional.digitoag : "",
                    conta_reembolso: this.infoContaAdd.infocontaopcional.conta ? this.infoContaAdd.infocontaopcional.conta : "",
                    digito_conta_reembolso: this.infoContaAdd.infocontaopcional.digitoconta ? this.infoContaAdd.infocontaopcional.digitoconta : "",
                    tipo_operacao_reembolso: this.infoContaAdd.infocontaopcional.operacao ? this.infoContaAdd.infocontaopcional.operacao : "",
                    tipo_conta_reembolso: this.infoContaAdd.infocontaopcional.tipoconta ? this.infoContaAdd.infocontaopcional.tipoconta : "",
                      solicita_reembolso: this.infoContaAdd.habilitareembolso ? "1" : "2" // 1 ou 0 
                    }
                  },
                  corretora: {
                    codigo_vendedor: "000457",
                    codigo_equipe: "008"
                  },
                  proposta_pls: "",
                  num_origem_promocao: "",
                  num_formulario: "",
                  meio_envio: "",
                  orgao: store.getters.getAliancaLotacaoOrgao ? store.getters.getAliancaLotacaoOrgao : '',
                  acao: "",
                  midia: "000014",
                  campanha: "",
                  migracao: "N",
                  migracao_origem: "",
                  observacao: "",
                  codigo_usuario: 1,
                  programa_origem: "Adesão proposta",
                  tipo_servidor: this.infoContaAdd.tipo_servidor ? this.infoContaAdd.tipo_servidor : "1",
                  matri_pensionista: this.infoContaAdd.matriculaservidorpensionista ? this.infoContaAdd.matriculaservidorpensionista : "",
                  cod_unidade_pag: this.infoContaAdd.unidadepagadora ? this.infoContaAdd.unidadepagadora : "",
                  url_envelope: "",
                  origem_sistema: "1",
                  login_consignacao: "",
                  senha_consignacao: "",
                  portabilidade: store.getters.getAliancaFlagPortabilidade == true ? "1" : "0"
                },
                tipoAcao: store.getters.getAliancaProposta != null ? "A" : "I",
                cpfTitular: this.cpf.replace('.','').replace('.','').replace('.','').replace('-','')
              })


          /***********************
            
           Preparação DPS e Opcionais

           ************************/

           if (retornosalvarprevenda != null || retornosalvarprevenda != undefined ){
            store.commit('mutAliancaProposta', retornosalvarprevenda)
          // Salvar DPS 
          let finaldps = []
          let dpsperguntas = []

          for (let i = 0; i < this.dependentes.length + 1; i++){

            let codindex = ''
            if (i < 10) codindex = '00' + (i + 1)
              else codindex = '0' + (i + 1)

                dpsperguntas = []
              for (let j = 2; j < this.dps.length; j++){
                let codpergunta = ''
                let tmpvalor = ''
                let tmpdesc = ''

                if (j < 10) codpergunta = '0' + (j - 1) + '0000'
                  else codpergunta = (j - 1) + '0000'

                    if ( this.dps[j][i].valor != 'Não' ){
                      tmpvalor = '1'
                      if (this.dps[j][i].observacao != 'text') tmpdesc = this.dps[j][i].observacao
                    } else {
                      tmpvalor = '2'
                      tmpdesc = ''
                    }

                    console.log(codpergunta);

                    dpsperguntas.push({
                      codigo_pergunta: this.dps[j][i].codper,
                      cd_pergunta: this.dps[j][i].cdper,
                      codigo_resposta: tmpvalor,
                      descricao_resposta: tmpdesc
                    })
                  }
                  finaldps.push({ 
                    codigo_index: codindex,
                    dps: { lista_complementos: dpsperguntas }
                  })
                }

                await salvarDPS({
                  proposta: {
                    num_proposta: retornosalvarprevenda.num_proposta,
                    beneficiarios: finaldps
                  }
                })

          /***********************
            
            Salvar Plano Opcionais

            ************************/

            let beneficiariosop = []
          // let possuiadicionais = false
          for (let i = 0; i < this.plano.detalhes.length; i++){
            if (this.plano.detalhes[i].opcionais != null){
              let codindex = ''
              if (i < 10) codindex = '00' + (i + 1)
                else codindex = '0' + (i + 1)

                  let adicionais = []
                for (let j = 0; j < this.plano.detalhes[i].opcionais.length; j++){
                  if (this.plano.detalhes[i].opcionais[j].selected == true) {
                    adicionais.push({
                      codigo_plano: this.plano.detalhes[i].opcionais[j].codopcional,
                      versao_plano: this.plano.detalhes[i].opcionais[j].versao_opcional
                    })
                  }
                }
                beneficiariosop.push({
                  nome: this.plano.detalhes[i].nome,
                  codigo_index: codindex,
                  planos_opcionais: adicionais
                })
              }
            }

            await salvarOpcionais({
              tipoAcao: "I",
              proposta: {
                num_proposta: retornosalvarprevenda.num_proposta,
                codigo_usuario: "1",
                programa_origem: "Adesão proposta",
                beneficiarios: beneficiariosop
              }
            })

            await criptografar({valor: retornosalvarprevenda.num_proposta, chaveCriptografia: "#!$a36?@"}).then(response => {
              this.url = `${process.env.VUE_APP_IMPRIMIR_PROPOSTA}/imprimirproposta.aspx?proposta=${response}&leg=1&AssDigital=1`
            })

            // 
            // Atualizar Envelope Docusign
            // 

            await marcarPropostaComoAtivada({ proposta: retornosalvarprevenda.num_proposta })

            if (this.vigenciaFlexivel){
              await marcarPropostaComoSeVigenciaFlexivel({ proposta: retornosalvarprevenda.num_proposta, flag: "1" })
            }

          }

          this.loading = false

          store.commit('mutAliancaPropostaFinalizada', this.protocolo)
          document.getElementById('step-progress').value = 100
          document.getElementById('step-progress-point4').classList.add("rounded-point-progress-ok")
          this.$router.push("assinar-proposta")
        },
      },
      computed: {
        listaOperadoras() {
          return store.getters.getAliancaPlanosOperadoras;
        },
        options_grauparentesco: {
          get() {
            return store.getters.getSimuleAquiGrauParentesco;
          },
          set(newVal) {
            store.commit("mutSimuleAquiGrauParentesco", newVal);
          },
        },
        planoReal: () => { 
          let operadoras = store.getters.getAliancaPlanosOperadoras
          let operadora_plano_selecionado = store.getters.getAliancaSelectedPlano.frontoperadoraid.operadoraprotheusid
          let objoperadorareal = {}
          for (let el in operadoras) {
            if (el == operadora_plano_selecionado) {
              objoperadorareal = operadoras[el]
            }
          }

          let planos = store.getters.getAliancaPlanosLista
          let plano_selecionado = store.getters.getAliancaSelectedPlanoProtheus
          let objplanoreal = {}
          planos.forEach((obj) => {
            if (obj.codPlano == plano_selecionado) objplanoreal = obj
          })

          let selectedPlano = store.getters.getAliancaSelectedPlano

          return { objplanoreal, objoperadorareal, selectedPlano }
        }
      },
      mounted(){
        this.buscaNovoCep();
        document.getElementById('step-progress').value = 97.65
        document.getElementById('step-progress-point1').classList.add("rounded-point-progress-ok")
        document.getElementById('step-progress-point2').classList.add("rounded-point-progress-ok")
        document.getElementById('step-progress-point3').classList.add("rounded-point-progress-ok")
        document.getElementById('globaletapa2').classList.remove("etapas-progresso-texto-disabled")
        document.getElementById('globaletapa3').classList.remove("etapas-progresso-texto-disabled")

        for (let i = 1; i <= 4; i++){
          document.getElementById('globaletapam' + i).classList.remove("etapas-progresso-mobile-show")
          document.getElementById('globaletapaprox' + i).classList.remove("div-proximo-etapa-mobile-show")
        }

        document.getElementById('globaletapam3').classList.add("etapas-progresso-mobile-show")
        document.getElementById('globaletapaprox3').classList.add("div-proximo-etapa-mobile-show")
      },
      async created() {      
        let objdps = store.getters.getAliancaObjDPS
        if (objdps != null){
          this.preparaFiltros()

          this.loading = true

          let vigenciaDiferenciada = await verificaVigenciaDiferenciada({
            Z8_CODEMP: this.planoReal.objoperadorareal.CODIGO_OPERADORA,
            Z8_GRPCOB: store.getters.getAliancaNumeroContrato,
            Z8_VERCON: this.planoReal.objoperadorareal.VERSAO_CONTRATO,
            Z8_CONEMP: this.planoReal.objoperadorareal.NUMERO_CONTRATO,
            Z8_SUBCON: this.planoReal.objoperadorareal.NUMERO_SUBCONTRATO,
            Z8_VERSUB: this.planoReal.objoperadorareal.VERSAO_SUBCONTRATO,
            Z8_SUBFAT: store.getters.getAliancaSubFatura
          })
          if (vigenciaDiferenciada != undefined) this.vigenciaFlexivel = vigenciaDiferenciada.utiliza == 1 ? true : false

            let diasposterioradesao = await retornaDiasPosteriorAdesao({
              Z8_CODEMP: this.planoReal.objoperadorareal.CODIGO_OPERADORA,
              Z8_GRPCOB: store.getters.getAliancaNumeroContrato,
              Z8_VERCON: this.planoReal.objoperadorareal.VERSAO_CONTRATO,
              Z8_CONEMP: this.planoReal.objoperadorareal.NUMERO_CONTRATO,
              Z8_SUBCON: this.planoReal.objoperadorareal.NUMERO_SUBCONTRATO,
              Z8_VERSUB: this.planoReal.objoperadorareal.VERSAO_SUBCONTRATO, 
              Z8_SUBFAT: store.getters.getAliancaSubFatura 
            })
          if (diasposterioradesao != undefined) this.diasposterioradesao = parseInt(diasposterioradesao.dias) + 2; this.diasposterioradesaoview = diasposterioradesao.dias

            this.datavigencia = this.getVigencia(this.planoReal.objoperadorareal.DATA_LIM_VENDA, this.planoReal.objoperadorareal.DATA_EXPORT).toLocaleDateString()

          if (this.vigenciaFlexivel) this.datainiciovigenciaflex = await this.preparaVigenciaFlexivel()

            let funcpublico = store.getters.getAliancaFuncPub
          if (funcpublico == 'Sim'){
            this.tipoorgaoentidade = 'Orgão'
          } else {
            this.tipoorgaoentidade = 'Entidade'
          }

          this.loading = false
        } else {
          this.$router.push("declaracao-saude")
        }
      }
    }
  </script>
